<template>
  <div :style="{width:'300px'}">
    <Form label-position="top" :model="psdFindForm" ref="psdFindForm" :rules="psdFindFormRule" v-show="!resetShow">
      <FormItem :label="$t('label.w199')" prop="account">
        <Input :placeholder="$t('pl.p1')" v-model="psdFindForm.account"/>
      </FormItem>
      <FormItem :label="$t('label.w201')" prop="code">
        <Row type="flex" :gutter="10">
          <Col span="15">
            <Input :placeholder="$t('pl.p8')" v-model="psdFindForm.code"/>
          </Col>
          <Col span="9">
            <Codebtn type="psdFind" :to="psdFindForm.account"/>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          :style="{marginTop:'35px'}"
          long
          :disabled="!psdFindForm.account || !psdFindForm.code"
          @click="submitValid"
        >{{$t('btn.b4')}}</Button>
      </FormItem>
    </Form>

    <Form
      v-show="resetShow"
      :model="pwdForm"
      label-position="top"
      :rules="pwdFormRule"
      ref="pwdForm"
    >
      <FormItem :label="$t('label.w202')" prop="pwd">
        <Input type="password" v-model="pwdForm.pwd" :placeholder="$t('pl.p3')" :maxlength="16"/>
      </FormItem>
      <FormItem :label="$t('label.w34')" prop="pwdagain">
        <Input type="password" v-model="pwdForm.pwdagain" :placeholder="$t('pl.p4')" :maxlength="16"/>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          :style="{marginTop:'35px'}"
          long
          :disabled="!pwdForm.pwd||!pwdForm.pwdagain"
          @click="submit"
          :loading="btnLoading"
        >{{$t('btn.b5')}}</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import formRule from "@/libs/formRule";
import Codebtn from "@/components/sendCodeBtn"
import Rsa from '@/libs/Rsa'
export default {
  components: { Codebtn },
  data() {
    return {
      psdFindForm: {
        account:'',
        code:''
      },
      psdFindFormRule: {
        account: formRule.logAccount,
        code: formRule.code
      },
      resetShow:false,
      btnLoading:false,
      pwdForm: {
        pwd:'',
        pwdagain:''
      },
      pwdFormRule: {
        pwd: formRule.logPwd,
        pwdagain: [
          { required: true, message: this.$t('msg.m6'), trigger: "submit" },
          {
            validator:(rule, value, callback)=>{
              if(value!=this.pwdForm.pwd) callback(new Error(this.$t('msg.m7')));
              else callback();
            },
            trigger: 'submit'
          }
        ]
      },
    };
  },
  methods: {
    // 验证码 验证
    async submitValid() {
      let valid=await this.$refs.psdFindForm.validate();
      if(!valid) return;
      let res = await this.$axios.post('/Member/RZJAuth/VerifRetrieveCode',{
        account:this.psdFindForm.account,
        code:this.psdFindForm.code
      });
      if(res.err) return res.throw();
      this.resetShow=true;
    },
    // 重设密码
    async submit(){
      this.btnLoading = true
      let valid=await this.$refs.pwdForm.validate();
      if(!valid) return;
      let res= await this.$axios.post("/Member/RZJAuth/ResetPassWord", {
        account:this.psdFindForm.account,
        code: this.psdFindForm.code,
        passWord:Rsa(this.pwdForm.pwd),
        affirmPassWord:Rsa(this.pwdForm.pwdagain)
      });
      this.btnLoading = false
      if (res.err) return res.throw();
      this.$Message.success(this.$t('msg.m40'));
      this.$router.push('login')
    }
  }
};
</script>


